import { FC } from "react";

import { Box } from "@mui/material";
import { useFormContext } from "react-hook-form";

import { AutomatedCommunicationCard } from ".././components/AutomatedCommunicationCard";
import { SendAutomatedEmailTestButton } from "../components/SendAutomatedEmailTestButton";
import { AutomatedCommunicationsFormData, RowKey } from "../types";

import { useTranslate } from "@/common/hooks/useTranslate";

interface ThankYouNonWinnerCardProps {
  openRow: RowKey | null;
  onToggleOpen: (row: RowKey) => void;
  isSmsEnabled: boolean;
  defaultContent: string;
}

export const ThankYouNonWinnerCard: FC<ThankYouNonWinnerCardProps> = ({
  openRow,
  onToggleOpen,
  isSmsEnabled,
  defaultContent,
}) => {
  const { t } = useTranslate();
  const form = useFormContext<AutomatedCommunicationsFormData>();
  return (
    <AutomatedCommunicationCard<AutomatedCommunicationsFormData>
      label={t("dashboard", "ticketing.automatedCommunications.row.thankYouNonWinner.label")}
      control={form.control}
      errors={form.formState.errors}
      dataEmailType="thank-you-non-winner"
      fields={{ subject: "thankYouNonWinner.subject", content: "thankYouNonWinner.content" }}
      enabled
      lockedOn
      toggleTooltip={t("dashboard", "ticketing.automatedCommunications.row.thankYouNonWinner.lockedTooltip")}
      chip={{
        label: t("dashboard", "ticketing.automatedCommunications.trigger.atAuctionClose"),
        showWhen: "enabled",
      }}
      collapse={{
        isOpen: openRow === "thank-you-non-winner",
        onToggle: () => onToggleOpen("thank-you-non-winner"),
      }}
      channelIcons={isSmsEnabled ? { email: true, sms: false } : undefined}
      body={{ defaultValue: defaultContent }}
      dataTestPrefix="thank-you-non-winner"
      footnote={
        <Box marginTop={2} display="flex" justifyContent="flex-start">
          <SendAutomatedEmailTestButton<AutomatedCommunicationsFormData>
            emailType="auction-thank-you-non-winner"
            subjectFieldName="thankYouNonWinner.subject"
            contentFieldName="thankYouNonWinner.content"
          />
        </Box>
      }
    />
  );
};
